// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessErrorMessage_container__1RHw7"};